import axios from 'axios';

const NON_RETRYABLE_QUERY_STATUSES = new Set([401, 403]);
const QUERY_RETRY_LIMIT = 3;

export const shouldRetryQuery = (
  failureCount: number,
  error: unknown,
): boolean => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;

    if (
      typeof status === 'number' &&
      NON_RETRYABLE_QUERY_STATUSES.has(status)
    ) {
      return false;
    }
  }

  return failureCount < QUERY_RETRY_LIMIT;
};
